import React, {
  useCallback, useEffect, useMemo, useState, ReactElement, Fragment,
} from 'react';
import Card from '../../../components/card/card.component';
import Button from '../../../components/button/button.component';
import ModalButtonBlock from '../../../components/modal-button-block/modal-button-block.component';
import ModalLayout from '../../../components/modal-layout/modal-layout.component';
import ModalLabel from '../../../components/modal-label/modal-label.component';
import ModalDescription from '../../../components/modal-description/modal-description.component';
import ModalFieldBlock from '../../../components/modal-field-block/modal-field-block.component';
import FieldSelect from '../../../components/field-select/field-select.component';
import MenuItemList from '../../../components/menu-item-list/menu-item-list.component';

const DealNewModal: ReactMemoComponent = React.memo((props: ReactComponentProps): ReactElement => {
  const INDEX_DEFAULT: number = 0;

  const {
    isOpen,
    dealTemplateList,
    onCloseModal,
    onConfirm,
  } = props;

  const [dealTemplateName, setDealTemplateName]: [string | null, Function] = useState(null);
  const [dealTemplateDescription, setDealTemplateDescription]: [string | null, Function] = useState(null);

  const menuItemDealTemplateList: ReactElement[] = useMemo((): ReactElement[] => MenuItemList({
    optionItemValueKey: 'name',
    optionList: dealTemplateList,
  }), [dealTemplateList]);

  const closeModal: MouseEventHandlerFunction = useCallback((): void => {
    if (onCloseModal) {
      onCloseModal();
    }
  }, []);

  const onDealTemplateChange: Function = useCallback((event: EventSelectChange, value: string): void => {
    dealTemplateList.forEach((dealTemplateItem: DealTemplate): void => {
      if (dealTemplateItem.name === value) {
        setDealTemplateName(dealTemplateItem.name);
        setDealTemplateDescription(dealTemplateItem.description || null);
      }
    });
  }, [dealTemplateList]);

  useEffect((): void => {
    if (!dealTemplateName && dealTemplateList) {
      dealTemplateList.forEach((dealTemplateItem: DealTemplate, dealTemplateIndex: number): void => {
        if (dealTemplateIndex === INDEX_DEFAULT) {
          setDealTemplateName(dealTemplateItem.name);
          setDealTemplateDescription(dealTemplateItem.description || null);
        }
      });
    }
  }, [dealTemplateList]);

  return (
    <ModalLayout isOpen={isOpen} title="New Deal" onCloseModal={closeModal}>
      <Card isContainer>
        {
          dealTemplateList && !!dealTemplateList.length && (
            <Fragment>
              <ModalLabel>
                Select template for a new deal:
              </ModalLabel>
              <ModalFieldBlock>
                <FieldSelect isPlain isBordered value={dealTemplateName} onChange={onDealTemplateChange}>
                  {menuItemDealTemplateList}
                </FieldSelect>
              </ModalFieldBlock>
              {
                dealTemplateDescription && (
                  <ModalDescription>
                    {dealTemplateDescription}
                  </ModalDescription>
                )
              }
            </Fragment>
          )
        }
      </Card>
      <ModalButtonBlock>
        <Button onClick={closeModal}>
          Cancel
        </Button>
        <Button
          isActive
          onClick={(): void => {
            onConfirm(dealTemplateName || null);
          }}
        >
          Create
        </Button>
      </ModalButtonBlock>
    </ModalLayout>
  );
});

export default DealNewModal;
